import styled from 'styled-components';

export const TestimonialsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 10px;
  max-width: 100%;
  overflow: hidden;
`;

export const TestimonialCard = styled.div`
  background: white;
  border: 1px solid rgba(145, 158, 171, 0.2);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 400px) {
    padding: 14px;
  }
`;

export const TestimonialHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

export const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;

  @media (max-width: 400px) {
    width: 40px;
    height: 40px;
  }
`;

export const TestimonialInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const TestimonialName = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin: 0;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const StarsContainer = styled.div`
  display: flex;
  gap: 2px;
`;

export const Star = styled.span`
  color: #ffd700;
  font-size: 16px;
`;

export const TestimonialText = styled.p`
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
  overflow-wrap: break-word;
  word-break: break-word;
`;
